import { customerv6Url_NPF } from '../api-urls';

export function createFastRegistryRequest({ token, event, captcha_response }) {
  return {
    url: `${customerv6Url_NPF}/fast-registry`,
    method: 'POST',
    timeout: 2500,
    params: {
      captcha_response
    },
    data: {
      token,
      event
    }
  };
}
